import { AutogenModelOriginLocation, AutogenRowOriginLocation } from "./autogen/AutogenModelOriginLocation";

export class ModelOriginLocation extends AutogenModelOriginLocation<RowOriginLocation> {
	constructor() {
		super(RowOriginLocation);
	}
}

export class RowOriginLocation extends AutogenRowOriginLocation {
}